import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IApp } from "../../../../models/application/i-app";
import { appRestClientInjectionToken } from "../../../../rest-clients/application/app/app-rest-client-injection-token";
import { IAppRestClient } from "../../../../rest-clients/application/app/i-app-rest.client";

@Injectable()
export class AppResolver implements Resolve<IApp> {
  constructor(@Inject( appRestClientInjectionToken ) private readonly _appRestClient: IAppRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<IApp> {
    const appId: string | null = route.paramMap.get( 'appId' );

    if ( appId === null ) {
      return Promise.reject();
    }

    return this._appRestClient.getApp( {
      recordId: appId
    } )
  }
}
